var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"toc",staticClass:"vue-toc menu",class:{ 'iframe': _vm.iframe }},[(_vm.title)?_c('h2',{staticClass:"title is-1",domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }